import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  NavbarContainer,
  NavInner,
  Logo,
  NavMenu,
  NavItem,
  MobileMenuButton,
  MobileMenu,
} from "./Navbar.style";
import trixie from "../../assets/trixie.png";
import hamburger from "./assets/hamburger.png";

export default function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isMobileMenuOpen]);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/projects", label: "Projects" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <NavbarContainer $isScrolled={isScrolled}>
      <NavInner ref={mobileMenuRef}>
        <Logo
          src={trixie}
          alt="Trixie Group logo"
          onClick={() => handleNavigate("/")}
        />

        {/* Desktop Navigation */}
        <NavMenu>
          {navLinks.map((link) => (
            <NavItem
              key={link.path}
              $isActive={isActive(link.path)}
              onClick={() => handleNavigate(link.path)}
            >
              {link.label}
            </NavItem>
          ))}
        </NavMenu>

        {/* Mobile Menu Button */}
        <MobileMenuButton
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <img
            src={hamburger}
            alt="Menu"
            style={{ transform: isMobileMenuOpen ? "rotate(90deg)" : "none" }}
          />
        </MobileMenuButton>

        {/* Mobile Menu */}
        <MobileMenu $isOpen={isMobileMenuOpen}>
          {navLinks.map((link) => (
            <NavItem
              key={link.path}
              $isActive={isActive(link.path)}
              onClick={() => handleNavigate(link.path)}
              $mobile
            >
              {link.label}
            </NavItem>
          ))}
        </MobileMenu>
      </NavInner>
    </NavbarContainer>
  );
}
